import { render, staticRenderFns } from "./ProDataPoint.vue?vue&type=template&id=53f7660d&scoped=true&"
import script from "./ProDataPoint.vue?vue&type=script&lang=js&"
export * from "./ProDataPoint.vue?vue&type=script&lang=js&"
import style0 from "./ProDataPoint.vue?vue&type=style&index=0&id=53f7660d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53f7660d",
  null
  
)

export default component.exports